import Script from 'next/script';

type Props = {
  children: React.ReactElement;
};

// Sem `POCKET_ENV`: o Pocket não carrega nem envia ao Mixpanel (que vai pelo `mixpanel-browser`,
// em `@/utils/common/analytics`). Ele fica para o perfil do usuário (`POCKET.profile`/`identify`).
const ScriptLoader = ({ children }: Props): React.ReactElement => (
  <>
    {/* eslint-disable-next-line @next/next/no-before-interactive-script-outside-document */}
    <Script
      // POCKET.js
      src='https://dnnsjdj5swfc3.cloudfront.net/front-end/libs/pocket.latest.js'
      strategy='beforeInteractive'
    />
    {children}
  </>
);

export default ScriptLoader;
